import * as logger from './logger';
import {
  FORCE_LANGUAGE_OVERRIDE_KEY,
  LANGUAGE_HEADER_KEY,
  LANGUAGE_KEY,
  SESSION_SESSION_ID_KEY,
  SESSION_SYSTEM_ID_KEY
} from './session.storage.keys';

const supportsSessionStorage = () => {
  return window && window.sessionStorage;
};

/** Read a value from session storage. */
export function read(key: string): object {
  let item;
  if (supportsSessionStorage()) {
    try {
      item = JSON.parse(window.sessionStorage.getItem(key) || 'null');
    } catch (_err) {
      logger.error(`An error occurred reading "${key}" from session storage.`);
    }
  } else {
    logger.error(
      `Session Storage is not detected for the browser. Cannot read "${key}".`
    );
  }
  return item;
}

/** Write data to session storage. */
export function write(key: string, json: object | string) {
  if (supportsSessionStorage()) {
    window.sessionStorage.setItem(key, JSON.stringify(json));
  } else {
    logger.error(
      `Session Storage is not detected for the browser. Cannot write "${key}".`
    );
  }
}

/** Remove data from session storage. */
export function remove(key: string) {
  if (supportsSessionStorage()) {
    window.sessionStorage.removeItem(key);
  } else {
    logger.error(
      `Session Storage is not detected for the browser. Cannot remove "${key}".`
    );
  }
}

/**
 * Drops this tab's session identity and language overrides.
 *
 * Environment and auth-mode stay so the next sign-in does not have to pick them
 * again. Same keys the session middleware already removes when CloseSession
 * starts or retrieveSession is rejected.
 */
export function clear() {
  remove(FORCE_LANGUAGE_OVERRIDE_KEY);
  remove(LANGUAGE_HEADER_KEY);
  remove(LANGUAGE_KEY);
  remove(SESSION_SESSION_ID_KEY);
  remove(SESSION_SYSTEM_ID_KEY);
}
